module.exports = __webpack_public_path__ + "img/goods.0066e0be.png";